/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
export const IContextViewService = createDecorator('contextViewService');
export const IContextMenuService = createDecorator('contextMenuService');
//# sourceMappingURL=contextView.js.map